import request from '@/router/axios'

const pre_fix = "/dotadmin/activity/"


export function addOperation(obj) {
  return request({
    url: pre_fix + 'addOperation',
    method: 'post',
    data: obj
  })
}

export function addOperationOverall(obj) {
  return request({
    url: pre_fix + 'addOperationOverall',
    method: 'post',
    data: obj
  })
}

export function querygoingOperationRewardOverall() {
  return request({
    url: pre_fix + 'querygoingOperationRewardOverall',
    method: 'post'
  })
}

export function queryOperationOverAll(obj) {
  return request({
    url: pre_fix + 'queryOperationOverAll',
    method: 'post',
    data: obj
  })
}

export function globalOperationList(obj) {
  return request({
    url: pre_fix + 'globalOperationList',
    method: 'post',
    data: obj
  })
}

export function pageOperationRewardOverallById(obj) {
  return request({
    url: pre_fix + 'pageOperationRewardOverallById',
    method: 'post',
    data: obj
  })
}

export function operationRewardOverallTjById(obj) {
  return request({
    url: pre_fix + 'operationRewardOverallTjById',
    method: 'post',
    data: obj
  })
}

export function currentMonthoperationRewardOverallTj() {
  return request({
    url: pre_fix + 'currentMonthoperationRewardOverallTj',
    method: 'post'
  })
}

export function queryOperation(obj) {
  return request({
    url: pre_fix + 'queryOperation',
    method: 'post',
    data: obj
  })
}

export function cacelOperation(obj) {
  return request({
    url: pre_fix + 'cacelOperation',
    method: 'post',
    data: obj
  })
}

export function operationList(obj) {
  return request({
    url: pre_fix + 'operationList',
    method: 'get',
    params: obj
  })
}

export function operatorTypeEnum() {
  return request({
    url: pre_fix + 'operatorTypeEnum',
    method: 'get'
  })
}

export function operationTj() {
  return request({
    url: pre_fix + 'operationTj',
    method: 'get'
  })
}

export function processTaskList(orderId) {
  return request({
    url: pre_fix + 'processTaskList',
    method: 'get',
    params:orderId
  })
}

export function processTask(orderId) {
  return request({
    url: pre_fix + 'processTask',
    method: 'get',
    params:orderId
  })
}

export function queryRewardByPlanId(planId) {
  return request({
    url: pre_fix + 'queryRewardByPlanId',
    method: 'get',
    params:planId
  })
}

export function cardList() {
  return request({
    url: pre_fix + 'cardList',
    method: 'get',
  })
}
